import React, { Component } from 'react';
import UserComponent from './User.js';
import {Spinner} from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import {UserAction, UserActionAdd, UserActionEdit, Category, Superviosor, RoleAction, UserStatusEdit,
  closeModalPopUp} from './UserActions'
import {InventoryAction, ReportsMaster} from '../Inventory/InventoryAction'
import ShowModalPopUp from '../ShowModalPopUp';
class Userindex extends Component {	  
	componentDidMount(){		
    this.props.inventoryAction();
    this.props.RolesAction();
    this.props.categoryAction();
    this.props.SuperviosorAction()
    this.props.actionReports()
    
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.showModalLogin, this.props.showModalLogin) && nextProps.showModalLogin === false){     
      this.props.inventoryAction();
      this.props.RolesAction();
      this.props.categoryAction();
      this.props.SuperviosorAction()
      this.props.actionReports()
    }
  } 
  render(){
    const{userData, inventoryData, categoryData, size, supervisorData,reportlist, rolesData, loginAction}= this.props; 
    let accessPermission;
    if(!_.isEmpty(loginAction)){    
      let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "USER_MANAGEMENT"})
      accessPermission = moduleAccess.screens[0].accessPermission
    }
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    } 
    return(
      <div className={(style) ? 'user userManagement' : "userSmall userManagement"}>
      {(this.props.showerror === true) ? (<ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/>) : null} 
      {this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>Loading...</p> : null}
      <UserComponent size={size} userData={userData} categoryData={categoryData} loginAction={loginAction}
      inventoryData={inventoryData} action={this.props} reportlist={reportlist} accessPermission={accessPermission}
      location={this.props.location} supervisorData={supervisorData} rolesData={rolesData}/>    
      </div>) 
  }
}
function mapStateToProps(state){
  return{
    userData:  state.UserReducer.userspayload,
    inventoryData: state.InventoryReducer.result,
    size: state.UserReducer.large,
    loginAction: state.LoginReducer.loginAction,
    categoryData: state.UserReducer.category,
    supervisorData: state.UserReducer.supervisor,
    rolesData: state.UserReducer.roles,
    reportlist: state.InventoryReducer.reportList,    
    showerror: state.UserReducer.showerror, 
    errmessage: state.UserReducer.errmessage,   
    isPending: state.UserReducer.isPending,  
    showModalLogin: state.UserReducer.showModalLogin, 
  }  
}

const mapDispatchToProps = (dispatch) => ({
  UserAction:  (a) =>dispatch(UserAction(a)),
  addnewUser:  (a) =>dispatch(UserActionAdd(a)),
  editUser:  (a) =>dispatch(UserActionEdit(a)),  
  inventoryAction:  () =>dispatch(InventoryAction()),   
  RolesAction:  () =>dispatch(RoleAction()),   
  categoryAction:  () =>dispatch(Category()), 
  SuperviosorAction:  () =>dispatch(Superviosor()), 
  UserStatusEdit:  (a) =>dispatch(UserStatusEdit(a)), 
  actionReports:  (a) =>dispatch(ReportsMaster(a)),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Userindex);
